window.VegasResposiveContent = {
	breakpoints: {
		xxl: 1400,
		xl: 1200,
		lg: 992,
		md: 768,
		sm: 576,
		xs: 0
	},

	init: function () {
		let $container = $('[data-content-responsive]');

		if ($container.length) {
			$container.each(function () {
				let $self = $(this),
					type = $self.data('content-responsive'),
					breakpoint = $self.data('content-breakpoint') || '',
					desktop =  $self.data('content-desktop'),
					mobile = $self.data('content-mobile'),
					poster_mobile = $container.data('poster-mobile'),
					poster_desktop = $container.data('poster-desktop')
				;

				if (VegasResposiveContent.checkResponsiveClass(breakpoint)) {
					VegasResposiveContent.setType(type, mobile, poster_mobile, $self);
				} else {
					VegasResposiveContent.setType(type, desktop, poster_desktop, $self);
				}
			})
		}
	},

	setType: function (type, src, poster, $container) {
		if (type === 'img'){
			$container.find('img').attr('src', src);
		} else if (type === 'video') {
			$container.html('');

			$container.prepend('<span class="vg-video-wrapper">' +
				'<video loop autoplay muted data-src="' + src + '" data-poster="' + poster + '">' +
				'  <source type="video/mp4" src="' + src + '" />' +
				'</video>' +
				'</span>')
			;
		}
	},

	checkResponsiveClass: function (breakpoint) {
		return window.innerWidth <= VegasResposiveContent.breakpoints[breakpoint];
	}
}

$(document).ready(function () {
	VegasResposiveContent.init();
});

$(window).resize(function () {
	VegasResposiveContent.init();
});